import {secured as axios} from '../../../axios';
import {imageAutoCompress} from '../../helper/image';

export class Actuality {
  static async sendActuality(
    actualityTilte,
    actualityDetail,
    image,
    communityId,
  ) {
    const compressedImage = await imageAutoCompress(image.file);

    const res = await axios.post(`/actuality`, {
      title: actualityTilte,
      description: actualityDetail,
      short_description: actualityDetail,
      community: communityId,
      image: {
        name: image.file.name,
        type: image.file.type,
        base64: compressedImage.base64,
      },
    });
    return res.status;
  }

  static async getActualities(communityId) {
    const res = await axios.get(`/community/${communityId}/actualities`);
    return res.data;
  }
}
